import { useFetchPage } from "~/core/composables/useFetchPage";
import { SearchMode, useSearch } from "~/core/composables/useSearch";
import { useSort } from "~/core/composables/useSort";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.type";
import type { UseFetchResponse } from "~/core/models/UseFetchResponse.interface";
import {
  Filters,
  type FiltersSelection,
  FiltersType,
  OPERATOR_RSQL_LIKE,
} from "~/core/models/filters";
import filtersUtils from "~/core/utils/filters.utils";
import affiliationService from "~/modules/relation/affiliation/services/affiliation.service";
import type { RelationEntity } from "~/modules/relation/models/RelationEntity.interface";

export function useFetchAffiliationChildren({
  organizationCode,
  businessUnitCode,
  searchMode = SearchMode.FILTER_SEARCH,
}: UseFetchParameters): UseFetchResponse<RelationEntity> {
  let service =
    affiliationService.getBusinessUnitAffiliationChildren.bind(
      affiliationService,
    );
  if (organizationCode !== undefined) {
    service =
      affiliationService.getOrganizationAffiliationChildren.bind(
        affiliationService,
      );
  }

  const appliedFilters: FiltersSelection = new Map([
    [
      Filters.ORGANIZATION_NAME,
      {
        key: "name",
        operator: OPERATOR_RSQL_LIKE,
        value: "",
        valueFormatter: filtersUtils.formatRSQLValue,
      },
    ],
  ]);

  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
    searchMode,
  );
  const { sort } = useSort();
  const { isLoading, results, error, fetchData } = useFetchPage({
    businessUnitCode,
    organizationCode,
    service,
    searchParams,
    sort,
  });

  return {
    isLoading,
    results,
    error,
    filters,
    fetchData,
    setFilter,
    search,
    onSearch,
  };
}
